import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import cn from 'classnames';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {
    color: colors.red,
    display: 'inline-flex',
    alignItems: 'center',
    '& *': {
      fontSize: fontSize.smallTitle,
    },
  },
  icon: {
    fill: colors.red,
    marginRight: 10,
    fontSize: 'inherit',
  },
}));

const TitleErrorMessage = ({ className, children }) => {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, className)}>
      <WarningIcon className={classes.icon} />
      {children}
    </div>
  );
};

TitleErrorMessage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default memo(TitleErrorMessage);
